module.exports = __webpack_public_path__ + "img/studioLogo.f62f76bd.png";